import { Modal, ModalPopInfo } from "../modules/Modal";

if (document.querySelector('.js-contact-modal')){
	const modal = new Modal('.js-contact-modal');
	window.toggleContactModal = (item) => {
		console.log(item);
		modal.toggleModal();
		modal.modalContentDOM.innerHTML = item.parentNode.getAttribute('data-branches')
	}
}

if (document.querySelector('.js-popup-modal') && document.cookie.indexOf('popupcookie=') === -1) {
	setTimeout(() => {
		let onClose = function() {
			document.cookie = `popupcookie=true;max-age=86400;samesite=lax;secure=true;path=/`;
		};
		let modalPopup = new ModalPopInfo('.js-popup-modal');

		modalPopup.open(onClose);
	}, 5000);
}
